import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

export default function LeftSideCard(props: any) {

  const theme = useTheme();
  let chartLogo;

  switch (props.pbiReportTypeId) {
    case 1:
      chartLogo = "chart1.png";
      break;
    case 2:
      chartLogo = "chart2.png";
      break;
    case 3:
      chartLogo = "chart3.png";
      break;

    default:
      chartLogo = "chart2.png";
      break;
  }
  return (
    <Card
      sx={{
        display: "flex",
        direction: "rtl",
        // background: "#25414E",
        border: ".001px solid #25414E",
        borderRadius: "5px !important",
        // color: "#fff",

        height: "100px"
      }}
      style={{ backgroundColor: "#25414D", marginRight: "20px", marginLeft: "20px" }}
      id={"left" + props.id}
    >
      <Grid
        container
        spacing={2}
        style={{ padding: "0 .1vh" }}
      >
        <Grid item xs={7} container>
          <Grid item xs={1} md={1} sm={1}>
            <DragIndicatorIcon style={{ color: "#fff", marginTop: "40px", marginRight: "10px" }} />
          </Grid>

          <Grid item xs={8} md={9} sm={9}>
            <Typography
              component="div"
              variant="h5"
              style={{ fontSize: "12px", color: "#FFFFFF", marginTop: "30%", marginRight: "20px" }}
            >
              {props.title}
            </Typography>
          </Grid>

          <Grid item xs={1} md={1} sm={1} style={{ paddingLeft: "5px" }}>
            <img src={`images/dashboard/search/sample-${props.pbiReportTypeId}.png`} className={"imgLefSideCard imgLefSideCard-max-size"} />
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

